import { newE2EPage } from "@stencil/core/testing";

describe("uic-radio-group", () => {
    it("should render", async () => {
        const page = await newE2EPage({
            html: `
            <uic-radio-group label="Group Label">
                <uic-radio>Label</uic-radio>
            </uic-radio-group>`,
        });

        const component = await page.find("uic-radio-group");
        expect(component).toMatchSnapshot();
    });

    it("should emit uicChange when checking a radio", async () => {
        const page = await newE2EPage({
            html: `
            <uic-radio-group>
                <uic-radio value="1">Label 1</uic-radio>
                <uic-radio id="radio2" value="2">Label 2</uic-radio>
                <uic-radio value="3">Label 3</uic-radio>
            </uic-radio-group>`,
        });

        const uicChange = await page.spyOnEvent("uicChange");

        const radio2 = await page.find("#radio2");
        radio2.setProperty("checked", true);

        await page.waitForChanges();

        expect(uicChange).toHaveReceivedEventTimes(1);
        expect(uicChange).toHaveReceivedEventDetail({ value: "2" });
    });

    it("should handle arrow keys to navigate", async () => {
        const page = await newE2EPage({
            html: `
            <uic-radio-group value="1">
                <uic-radio id="radio1" value="1">Label 1</uic-radio>
                <uic-radio id="radio2" value="2">Label 2</uic-radio>
            </uic-radio-group>`,
        });

        const component = await page.find("uic-radio-group");
        const radio1 = await page.find("#radio1");
        const radio2 = await page.find("#radio2");

        page.keyboard.press("Tab"); // focus first radio
        page.keyboard.press("ArrowDown"); // focus second radio

        await page.waitForChanges();

        expect(await radio2.getProperty("checked")).toBe(true);
        expect(await component.getProperty("value")).toBe("2");

        page.keyboard.press("ArrowUp"); // focus first radio
        await page.waitForChanges();

        expect(await radio1.getProperty("checked")).toBe(true);
        expect(await component.getProperty("value")).toBe("1");
    });
});
